/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PresetItemCreate } from './presetItemCreate';
import type { PresetUpdateVisibility } from './presetUpdateVisibility';

export interface PresetUpdate {
  title?: string | null;
  description?: string | null;
  visibility?: PresetUpdateVisibility;
  items?: PresetItemCreate[] | null;
  filters_json?: string | null;
  stages_json?: string | null;
}
